import React, { createContext, useContext } from "react";
import { useAuth } from "../auth/useAuth";
import { useGetUserPermissionsQuery } from "../features/projects/projectsApi";
const PermissionContext = createContext(undefined);
export const PermissionProvider = ({ children, }) => {
    const { account } = useAuth();
    const userEmail = (account === null || account === void 0 ? void 0 : account.username) || "";
    // Fetch user permissions from API
    const { data: permissions = [], isLoading, error, } = useGetUserPermissionsQuery(userEmail, {
        skip: !userEmail,
    });
    const status = error && "status" in error
        ? error.status
        : undefined;
    const isAuthError = !isLoading && !!error && (status === 401 || status === 403);
    // 403 on the bootstrap call = authenticated tenant user who is not a provisioned app user.
    const isForbidden = !isLoading && status === 403;
    // Helper function to check if user has a specific permission
    const hasPermission = (moduleName, permissionType) => {
        return permissions.some((p) => p.moduleName.toLowerCase() === moduleName.toLowerCase() &&
            p.permissionType.toLowerCase() === permissionType.toLowerCase() &&
            p.isAllowed === true);
    };
    // Convenience methods for common permission checks
    const canRead = (moduleName) => hasPermission(moduleName, "read");
    const canUpdate = (moduleName) => hasPermission(moduleName, "update");
    const canCreate = (moduleName) => hasPermission(moduleName, "create");
    const canDelete = (moduleName) => hasPermission(moduleName, "delete");
    return (React.createElement(PermissionContext.Provider, { value: {
            permissions,
            isLoading,
            isAuthError,
            isForbidden,
            hasPermission,
            canRead,
            canUpdate,
            canCreate,
            canDelete,
        } }, children));
};
// Hook to use permissions in components
export const usePermissions = () => {
    const context = useContext(PermissionContext);
    if (!context) {
        throw new Error("usePermissions must be used within a PermissionProvider");
    }
    return context;
};
